window.addEventListener('DOMContentLoaded', ()=>{
  // quick shop modal customize
  const quick_modals = document.querySelectorAll('.modal--quick-shop');
  const modal_buttons = document.querySelectorAll('.quick-product__btn');
  quick_modals.forEach((elm)=>{
    document.body.appendChild(elm);
  });
  

  if(document.body.classList.contains('template-product')) {
    setTimeout(()=>{
      const quick_modals = document.querySelectorAll('.modal--quick-shop');
      quick_modals.forEach((elm)=>{
        if(!elm.parentNode.classList.contains('template-product')) {
          document.body.appendChild(elm);
        }
      });
    }, 3000);
  }
  
  modal_buttons.forEach((btn)=>{
    if(btn.getAttribute('aria-expanded') != 'false') {
      btn.setAttribute('aria-expanded', false);
    }
    btn.addEventListener('click', ()=>{
      if(btn.getAttribute('aria-expanded') == 'false') {
        setTimeout(()=>{
          btn.click();
        }, 500);
      }
    });
  });
  // quick shop modal customize

  //  drawer customize
  const drawer_button = document.querySelector('.js-drawer-open-nav');
  drawer_button.addEventListener('click', ()=>{
    const header = document.querySelector('#SiteHeader');
    let header_position = header.getBoundingClientRect().bottom;
    const product_header = document.querySelector('.product--page-nav');
    if(product_header != null) {
      header_position = product_header.getBoundingClientRect().bottom;
    }
    const drawer = document.querySelector('#NavDrawer');
    drawer.style.top = `${header_position}px`;
  });
  //  drawer customize
});

function anchorTo(class_name) {
  const header_height = document.querySelector('#SiteHeader').clientHeight;
  const target_position = document.querySelector(class_name).offsetTop;
  window.scrollTo({
    top: target_position - header_height - 20,
    behavior: 'smooth'
  });
}

//  smooth scroll

function switchDisplay(elm) {
  elm.classList.toggle('force-display');
}

async function openFAQ() {
  const faq_button_wrap = document.querySelector('.Avada-Preview_Button');
  const faq_button = document.querySelector('#Avada-FAQ_WidgetTrigger');
  await switchDisplay(faq_button_wrap);
  faq_button.click();
  switchDisplay(faq_button_wrap);
}

  // modal
  function modalOpen(className) {
    const modal = document.querySelector(`.${className}`);
    if(modal != null && !modal.classList.contains('modal-open')) {
      modal.classList.add('modal-open');
      document.body.classList.add('no-scroll');
      modal_bg.classList.add('modal-bg-open')
    }
  }
  
  function modalClose() {
    const modal = document.querySelector('.modal-open');
    if(modal != null) {
      modal.classList.remove('modal-open');
      document.body.classList.remove('no-scroll');
      modal_bg.classList.remove('modal-bg-open')
    }
  }

  function openResaleModal() {
    const resale_button = document.querySelector('#BIS_trigger');
    if(resale_button != null) {
      resale_button.click();
    }
  }

  function openVariantModal() {
    const swatches = document.querySelectorAll('.variant__input--color-swatch');
    swatches.forEach((swatch)=>{
      if(swatch.checked) {
        if(swatch.dataset.colorName.match('予約')) {
          const color_name = swatch.dataset.colorName.replace(/\(.*\)/gm, '');
          modalOpen(`cart-modal${color_name}`);
          console.log(`cart-modal${color_name}`);
        } else {
          const color_name = swatch.dataset.colorName;
          modalOpen(`cart-modal${color_name}`);
          console.log(`cart-modal${color_name}`);
        }
      }
    });
  }

  const modal_bg = document.createElement('div');
  modal_bg.classList.add('modal-bg');
  modal_bg.setAttribute('onclick', 'modalClose()');
  window.addEventListener('DOMContentLoaded', ()=>{
    document.body.appendChild(modal_bg);
  });
  // modal

  //  CHECK WISHED
  function checkWished(elm) {
    const active_var = document.querySelector('.fav-active-variant');
    if(active_var != null) {
      if(active_var.disabled) {
        elm.classList.add('is-wished');
      } else {
        if(elm.classList.contains('is-wished')) {
          elm.classList.remove('is-wished');
        }
      }
    }
  }

// ADD TO FAV 
  function addToFav() {
    const active_var = document.querySelector('.fav-active-variant');
    if(active_var != null) {
      active_var.click();
    }
  }
// ADD TO FAV 

// fix avada faq
 window.addEventListener('DOMContentLoaded', ()=>{
   const avada_btns = document.querySelectorAll('.Avada-Faq__IconCard--light_theme');
   const avada_cats = document.querySelectorAll('.Avada-Faq_Category-Title');
   if(avada_btns != null) {
     avada_btns.forEach((elm)=>{
       elm.addEventListener('click', (e)=>{
         e.preventDefault();
         e.stopPropagation();
         const header_height = document.querySelector('#SiteHeader').clientHeight;
         for(let i in avada_cats) {
           if(avada_cats[i].textContent == elm.textContent) {
             window.scrollTo({
                top: avada_cats[i].offsetTop - header_height,
                behavior: 'smooth'
              });
           }
         }
       }, true);
     });
   }
 });
// fix avada faq

// add 2024.02.13 SHP_MEIKO-80 SP版拡大画像の調整 @ci-inada
// touch open
document.addEventListener('DOMContentLoaded', ()=>{
  if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
    const pswp_btn = document.querySelector('.js-photoswipe__zoom');
    const pswp_img = document.querySelectorAll('.photoswipe__image');
    if(pswp_btn != null && pswp_img != null) {
      pswp_img.forEach((img)=>{
        let move_X = 0
        img.addEventListener('touchmove', (e)=>{
          move_X = e.changedTouches[0].pageX
        });
        img.addEventListener('touchend', (e)=>{
          if(move_X < 10) {
            pswp_btn.click();
          }
        });
      });
    }
  }
});
// add 2024.02.13 SHP_MEIKO-80 SP版拡大画像の調整 @ci-inada
